import { __module as t } from "../../../../_virtual/interopRequireDefault.mjs";
(function(o) {
  function r(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  o.exports = r, o.exports.__esModule = !0, o.exports.default = o.exports;
})(t);
//# sourceMappingURL=interopRequireDefault.mjs.map
